import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import {
  Receipt, Calendar, CreditCard, CheckCircle, Clock, Download
} from 'lucide-react';

const Pagamenti = () => {
  const [pagamenti, setPagamenti] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { caricaPagamenti(); }, []);

  const caricaPagamenti = async () => {
    try {
      setLoading(true);
      const response = await api.get('/pagamenti/pagamenti/miei_pagamenti/');
      setPagamenti(response.data.results || response.data || []);
    } catch (error) {
      console.error('Errore:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatData = (dataStr) => {
    return new Date(dataStr).toLocaleDateString('it-IT', { day: '2-digit', month: 'long', year: 'numeric' });
  };

  const getMetodoLabel = (metodo) => {
    const metodi = { 'CONTANTI': 'Contanti', 'BONIFICO': 'Bonifico', 'CARTA': 'Carta', 'ASSEGNO': 'Assegno', 'ALTRO': 'Altro' };
    return metodi[metodo] || metodo;
  };

  const getStatoLabel = (stato) => {
    const stati = { 'COMPLETATO': 'Completato', 'IN_ATTESA': 'In attesa', 'FALLITO': 'Fallito', 'RIMBORSATO': 'Rimborsato' };
    return stati[stato] || stato;
  };

  if (loading) {
    return (
      <div className="du-loading">
        <div className="du-spinner"></div>
        <p>Caricamento pagamenti...</p>
      </div>
    );
  }

  if (pagamenti.length === 0) {
    return (
      <div className="du-empty">
        <Receipt size={56} strokeWidth={1.5} />
        <h3>Nessun Pagamento</h3>
        <p>Non ci sono ancora pagamenti registrati</p>
      </div>
    );
  }

  return (
    <div className="du-pag-section">
      <div className="du-section-head">
        <h2>Storico Pagamenti</h2>
        <p>{pagamenti.length} pagamento{pagamenti.length !== 1 ? 'i' : ''}</p>
      </div>

      <div className="du-pag-list">
        {pagamenti.map((pag) => (
          <div key={pag.id} className="du-pag-card">
            <div className="du-pag-top">
              <div className="du-pag-title">
                <Receipt size={18} />
                <div>
                  <h4>Pagamento #{pag.numero_ricevuta || pag.id}</h4>
                  <p className="date">{formatData(pag.data_pagamento)}</p>
                </div>
              </div>
              <span className={`du-pag-badge ${pag.stato.toLowerCase()}`}>
                {pag.stato === 'COMPLETATO' && <CheckCircle size={12} />}
                {pag.stato === 'IN_ATTESA' && <Clock size={12} />}
                {getStatoLabel(pag.stato)}
              </span>
            </div>

            <div className="du-pag-body">
              <div className="du-pag-row">
                <span className="du-pag-lbl">Importo</span>
                <span className="du-pag-val amount">€ {parseFloat(pag.importo).toFixed(2)}</span>
              </div>
              <div className="du-pag-row">
                <span className="du-pag-lbl">Metodo</span>
                <span className="du-pag-val"><CreditCard size={14} /> {getMetodoLabel(pag.metodo)}</span>
              </div>
              {pag.abbonamento_info && (
                <div className="du-pag-row">
                  <span className="du-pag-lbl">Abbonamento</span>
                  <span className="du-pag-val">{pag.abbonamento_info}</span>
                </div>
              )}
              {pag.note && (
                <div className="du-pag-note"><p>{pag.note}</p></div>
              )}
            </div>

            {pag.ricevuta_url && (
              <div className="du-pag-footer">
                <button className="du-btn-receipt">
                  <Download size={14} /> Scarica ricevuta
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pagamenti;
